import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader';

// Singleton loader — reused across all load calls
let _loader: GLTFLoader | null = null;

function getLoader(): GLTFLoader {
  if (!_loader) {
    // DRACOLoader handles KHR_draco_mesh_compression — required for compressed GLBs.
    // Decoder files are served from public/draco/ (copied from three/examples/jsm/libs/draco).
    const draco = new DRACOLoader();
    draco.setDecoderPath('/draco/');

    _loader = new GLTFLoader();
    _loader.setDRACOLoader(draco);
  }
  return _loader;
}

/**
 * Loads a GLTF / GLB file and returns the root Object3D.
 *
 * Shadows are enabled on every mesh in the loaded hierarchy.
 * Throws (rejects) on any loading error so callers can fall back gracefully.
 */
export function loadGLTF(path: string): Promise<THREE.Object3D> {
  return new Promise((resolve, reject) => {
    getLoader().load(
      path,
      (gltf) => {
        const root = gltf.scene;
        root.traverse((child) => {
          if (child instanceof THREE.Mesh) {
            child.castShadow = true;
            child.receiveShadow = true;
          }
        });
        resolve(root);
      },
      undefined, // onProgress — hook in if you need a progress bar
      (err) => reject(err)
    );
  });
}
